var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.98 11.969a5.616 5.616 0 0 0 2.055-4.352C27.035 4.515 24.529 2 21.438 2c-3.088 0-5.592 2.51-5.597 5.61-6.014.166-10.84 5.114-10.84 11.192C5 24.987 9.994 30 16.154 30c5.246 0 9.634-3.64 10.825-8.537h-5.85a5.624 5.624 0 0 1-4.976 3.012c-3.108 0-5.628-2.53-5.628-5.65 0-3.122 2.52-5.651 5.628-5.651a5.624 5.624 0 0 1 4.977 3.011h5.86a11.2 11.2 0 0 0-2.01-4.216z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChr);
export default __webpack_public_path__ + "static/media/CHR.dc2d61854e47b3f348c1b4222f35e2b7.svg";
export { ForwardRef as ReactComponent };